export default {
  cotacaoId(state) {
    return state.cotacaoId;
  },
};
